module.exports = "/packs/images/svg/ireland/facilities/football_pitch~0d42ab93b5337e0168c4840823cbb7bd.svg";